import React, { FC, useState } from "react";

type Props = {
  field: {
    name: string;
    value: number;
    onChange: (e: number) => void;
    onBlur: () => void;
  };
  form: {
    setFieldValue: (
      field: string,
      value: number,
      shouldValidate?: boolean
    ) => void;
  };
  starId: string | number;
};

const StarIcon: FC<{ filled: boolean }> = ({ filled }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.22448 30.8854C6.4516 31.2827 5.57647 30.5884 5.73206 29.7015L7.39152 20.2425L0.346856 13.5292C-0.311505 12.9018 0.0292951 11.7547 0.911274 11.6294L10.7082 10.2377L15.0765 1.58461C15.47 0.80513 16.5359 0.80513 16.9294 1.58461L21.2976 10.2377L31.0946 11.6294C31.9766 11.7547 32.3174 12.9018 31.659 13.5292L24.6143 20.2425L26.2738 29.7015C26.4294 30.5884 25.5543 31.2827 24.7814 30.8854L16.0029 26.3735L7.22448 30.8854Z"
      style={{
        fill: filled ? "#FFE459" : "#FFFFFF",
        transition: "fill 0.3s",
      }}
    />
    <path
      d="M5.73206 29.7015C5.57647 30.5884 6.4516 31.2827 7.22448 30.8854L16.0029 26.3735L24.7814 30.8854C25.5543 31.2827 26.4294 30.5884 26.2738 29.7015L24.6143 20.2425L31.659 13.5292C32.3174 12.9018 31.9766 11.7547 31.0946 11.6294L21.2976 10.2377L16.9294 1.58461C16.5359 0.80513 15.47 0.80513 15.0765 1.58461L10.7082 10.2377L0.911274 11.6294C0.0292951 11.7547 -0.311505 12.9018 0.346856 13.5292L7.39152 20.2425L5.73206 29.7015ZM15.5413 24.1652L8.16977 27.954L9.55828 20.0394C9.62373 19.6663 9.50066 19.2843 9.23278 19.029L3.41911 13.4888L11.5237 12.3375C11.8588 12.2899 12.1513 12.0759 12.3093 11.7628L16.0029 4.44615L19.6965 11.7628C19.8546 12.0759 20.1471 12.2899 20.4821 12.3375L28.5868 13.4888L22.7731 19.029C22.5052 19.2843 22.3821 19.6663 22.4476 20.0394L23.8361 27.954L16.4646 24.1652C16.1734 24.0156 15.8325 24.0156 15.5413 24.1652Z"
      fill="#FFE459"
      stroke="#FFE459"
      strokeWidth="0.5"
    />
  </svg>
);

export const StarRating: FC<Props> = ({ field, form, starId }) => {
  const rating = field.value ?? 0;
  const [hover, setHover] = useState<number | null>(null);

  const handleRatingChange = (value: number) => {
    form.setFieldValue(field.name, value);
  };

  return (
    <div className="full-stars mb-3 d-flex justify-content-center">
      <div className="rating-group">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          const isFilled =
            hover !== null ? starValue <= hover : starValue <= rating;
          return (
            <div
              key={starValue}
              className="star-container"
              onMouseEnter={() => setHover(starValue)}
              onMouseLeave={() => setHover(null)}
            >
              <input
                type="radio"
                id={`${starId}-${starValue}`}
                name={field.name}
                value={starValue}
                checked={rating === starValue}
                onChange={() => handleRatingChange(starValue)}
              />
              <label htmlFor={`${starId}-${starValue}`}>
                <StarIcon filled={isFilled} />
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};
